export default "__VITE_ASSET__ec57d846__"